/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import home from '@/views/home'
import bind from '@/components/bind/bind'
import commonproblem from '@/components/commonproblem/commonproblem'
import nobind from '@/components/commonproblem/nobind/nobind'

import nobindmsg from '@/components/commonproblem/nobindmsg/nobindmsg'

import appopen from '@/components/commonproblem/appopen/appopen'

import brightscreentime from '@/components/commonproblem/brightscreentime/brightscreentime'


import hw from '@/components/commonproblem/nobindmsg/hw/hw'

import oppo from '@/components/commonproblem/nobindmsg/oppo/oppo'

import iphone from '@/components/commonproblem/nobindmsg/iphone/iphone/'

import sx from '@/components/commonproblem/nobindmsg/sx/sx'

import vivo from '@/components/commonproblem/nobindmsg/vivo/vivo'

import xm from '@/components/commonproblem/nobindmsg/xm/xm'

import Intercom from '@/views/intercom'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/bind',
      name: 'bind',
      component: bind
    }, {
      path: '/intercom',
      name: 'Intercom',
      component: Intercom
    },
    {
      path: '/commonproblem',
      name: 'commonproblem',
      component: commonproblem
    },
    {
      path: '/commonproblem',
      name: 'common_problem',
      component: commonproblem
    },
    {
      path: '/nobind',
      name: 'nobind',
      component: nobind
    },
    {
      path: '/nobindmsg',
      name: 'nobindmsg',
      component: nobindmsg
    },
    {
      path: '/appopen',
      name: 'appopen',
      component: appopen
    },
    {
      path: '/brightscreentime',
      name: 'brightscreentime',
      component: brightscreentime
    },
    {
      path: '/hw',
      name: 'hw',
      component: hw
    },
    {
      path: '/iphone',
      name: 'iphone',
      component: iphone
    },
    {
      path: '/oppo',
      name: 'oppo',
      component: oppo
    },
    {
      path: '/sx',
      name: 'sx',
      component: sx
    },
    {
      path: '/vivo',
      name: 'vivo',
      component: vivo
    },
    {
      path: '/xm',
      name: 'xm',
      component: xm
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js